import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock } from "vue"

import { SwatchColorImageCustomizerOption } from '@/types/productServerApi';
import CustomizerMiniRadioSwatch from '@/shared/product/customizer/ui/CustomizerMiniRadioSwatch.vue';
import useProductDetailPage from '@/shared/product/details/useProductDetailPage';
import useCustomizer from '@/shared/product/customizer/useCustomizer';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomizerMiniTabSwatch',
  props: {
    id: null,
    options: null
  },
  setup(__props: any) {




const { updateSku } = useProductDetailPage();
const { getMaterialImageUrl } = useCustomizer();


return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
    return (_openBlock(), _createBlock(CustomizerMiniRadioSwatch, {
      id: __props.id + option.sku,
      key: option.sku,
      value: option.sku,
      name: __props.id,
      label: option.title,
      "img-url": _unref(getMaterialImageUrl)(option.image),
      "hex-code": option.hexCode,
      checked: option.selected,
      onChange: ($event: any) => (_unref(updateSku)(option.sku))
    }, null, 8, ["id", "value", "name", "label", "img-url", "hex-code", "checked", "onChange"]))
  }), 128))
}
}

})